import { createSlice } from '@reduxjs/toolkit'

export const sessionSlice = createSlice({
    name: 'auth/session',
    initialState: {
        token: '',
        uuid: '',
        signedIn: false,
    },
    reducers: {
        onSignInLoggedIn: (state, action) => {
            state.signedIn = true
        },
        onSignInSuccess: (state, action) => {
            state.signedIn = false
            state.token = action.payload.token
            state.uuid = action.payload.user.uuid
        },
        onSignOutSuccess: (state) => {
            state.signedIn = false
            state.token = ''
            state.uuid = ''
        },
        setToken: (state, action) => {
            state.token = action.payload
        },
        setUuid: (state, action) => {
            state.uuid = action.payload
        },
    },
})

export const { onSignInSuccess, onSignOutSuccess, onSignInLoggedIn, setToken } =
    sessionSlice.actions

export default sessionSlice.reducer
